import script from "./TextBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextBlock.vue?vue&type=script&setup=true&lang=ts"

import "./TextBlock.vue?vue&type=style&index=0&id=dc5bebf2&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc5bebf2"]])

export default __exports__